<div class="cache-control-container">
  <!-- Tabs -->
  <ul class="tab tab-pills">
    @for (tab of tabs; track $index) {
<li
        (click)="activeTab = tab.id"
        (mouseenter)="tab.hover = true" (mouseleave)="tab.hover = false">
      <a [ngClass]="{'activeTab': tab.id === activeTab, 'inactiveTab': tab.id !== activeTab && tab.hover}">{{ tab.name }}</a>
    </li>
}
  </ul>
  <hr>

  <!-- ============ Tab 1: Custom Cache ============ -->
  @if (activeTab === 1) {

    <div class="searchRow">
      <div class="toolbar-left">
        <i class="fa fa-refresh gt-refresh toolbar-icon"
           (click)="refresh()"
           ap-tooltip [tooltipContent]="'Refresh Data'" [direction]="'right'"></i>
        <span class="btn btn-success btn-xs action-btn" (click)="addCache()">Add New</span>
        <span class="btn btn-success btn-xs action-btn" (click)="confirmRefreshAll()">Refresh All</span>
        @if (hasEvictAccess) {

          <span class="btn btn-success btn-xs action-btn" (click)="confirmEvictAll()">Evict All Cache</span>
          <select class="form-control input-sm inline-select"
                  [(ngModel)]="evictSelectedCacheValue">
            <option value="" disabled>Select Cache</option>
            @for (cache of cacheDropdown; track $index) {
<option [value]="cache">{{ cache }}</option>
}
          </select>
          <span class="btn btn-success btn-xs action-btn" (click)="confirmEvictSelected()">Evict Selected Cache</span>
          @if (evictCacheLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
        
}
      </div>
      @if (cacheObjList.length > 0) {
<div class="toolbar-right">
        <div class="searchDiv">
          <div class="searchBlock">
            <input type="text" class="contentSearch"
                   [(ngModel)]="tableSearchText"
                   placeholder="Search">
          </div>
          <i class="fa fa-search searchIcons"></i>
        </div>
      </div>
}
    </div>

    <!-- Loading -->
    @if (loading) {
<div class="loading-indicator">
      <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i>
    </div>
}

    <!-- Table -->
    @if (!loading && filteredCacheObjList.length > 0) {

      <div class="table-scroll-wrapper">
        <table class="cache-table">
          <thead>
            <tr>
              <th (click)="sortBy('object_name')" class="sortable-th">
                Cached Object Key
                <i class="fa" [ngClass]="getSortIcon('object_name')"></i>
              </th>
              <th (click)="sortBy('input_filter')" class="sortable-th">
                Filter Condition
                <i class="fa" [ngClass]="getSortIcon('input_filter')"></i>
              </th>
              <th (click)="sortBy('recordCount')" class="sortable-th">
                Count
                <i class="fa" [ngClass]="getSortIcon('recordCount')"></i>
              </th>
              <th (click)="sortBy('is_cached')" class="sortable-th">
                Is Cached
                <i class="fa" [ngClass]="getSortIcon('is_cached')"></i>
              </th>
              <th (click)="sortBy('is_stale')" class="sortable-th">
                Is Stale
                <i class="fa" [ngClass]="getSortIcon('is_stale')"></i>
              </th>
              <th (click)="sortBy('update_date')" class="sortable-th">
                Last Updated
                <i class="fa" [ngClass]="getSortIcon('update_date')"></i>
              </th>
              <th>Refresh Cache</th>
              <th>JSON Data Diff</th>
              <th>Download Cache</th>
              <th>Remove Cache</th>
              <th>Enable/Disable Cache</th>
            </tr>
          </thead>
          <tbody>
            @for (t of paginatedCacheObjList; track $index) {
<tr>
              <td>
                <i class="fa fa-info-circle info-icon"
                   ap-tooltip [tooltipContent]="t.redis_obj_key" [direction]="'bottom'"></i>
                {{ t.object_name }}
              </td>
              <td>{{ t.input_filter }}</td>
              <td>{{ t.recordCount }}</td>
              <td>{{ t.is_cached }}</td>
              <td>{{ t.is_stale }}</td>
              <td>{{ t.update_date }}</td>
              <td class="action-cell">
                @if (t.is_cached === 'Yes') {
<i class="fa fa-refresh gt-refresh fa-lg action-icon"
                   (click)="refreshCacheObj(t.object_id)"
                   ap-tooltip [tooltipContent]="'Refresh Data'" [direction]="'right'"></i>
}
              </td>
              <td class="action-cell">
                <button type="button" class="btn btn-primary btn-xs viewDiffBtn"
                        (click)="showDiffModal(t.object_name, t.input_filter)">View</button>
              </td>
              <td class="action-cell">
                @if (t.is_cached === 'Yes') {
<i class="fa fa-download fa-lg action-icon"
                   (click)="downloadCacheObj(t.object_id, t.redis_obj_key)"
                   ap-tooltip [tooltipContent]="'Download Data'" [direction]="'right'"></i>
}
              </td>
              <td class="action-cell">
                @if (t.is_cached === 'Yes') {
<i class="fa fa-trash-o fa-lg action-icon"
                   (click)="removeCacheObj(t.object_id)"
                   ap-tooltip [tooltipContent]="'Remove Data'" [direction]="'right'"></i>
}
              </td>
              <td class="action-cell">
                <ap-toggle
                  [(ngModel)]="t.switchVal"
                  [ariaLabel]="'Enable or disable cache'"
                  (onChange)="onToggleChange(t, $event)">
                </ap-toggle>
              </td>
            </tr>
}
          </tbody>
        </table>
      </div>

      <div class="pagination-bar">
        <div class="pagination-controls">
          <button class="pagination-btn" [disabled]="currentPage <= 1" (click)="goToPage(1)">&laquo;</button>
          <button class="pagination-btn" [disabled]="currentPage <= 1" (click)="goToPage(currentPage - 1)">&lsaquo;</button>
          <span class="pagination-info">{{ currentPage }} of {{ totalPages }}</span>
          <button class="pagination-btn" [disabled]="currentPage >= totalPages" (click)="goToPage(currentPage + 1)">&rsaquo;</button>
          <button class="pagination-btn" [disabled]="currentPage >= totalPages" (click)="goToPage(totalPages)">&raquo;</button>
        </div>
        <select class="page-size-select" [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          @for (size of pageSizeOptions; track $index) {
<option [ngValue]="size">{{ size }} / Page</option>
}
        </select>
        <span class="pagination-info-text">{{ paginationInfoText }}</span>
      </div>
    
}

    @if (!loading && filteredCacheObjList.length === 0 && cacheObjList.length > 0) {
<div class="noSettings">
      No matching cache entries found.
    </div>
}
    @if (!loading && cacheObjList.length === 0) {
<div class="noSettings">
      No cache entries to display.
    </div>
}
  
}

  <!-- ============ Tab 2: System Cache ============ -->
  @if (activeTab === 2) {

    <div class="system-cache-controls">
      <select class="form-control input-sm inline-select"
              [(ngModel)]="selectedCache"
              (ngModelChange)="getAllCacheData($event)">
        <option value="" disabled>Select Cache</option>
        @for (cache of cacheDropdown; track $index) {
<option [value]="cache">{{ cache }}</option>
}
      </select>
    </div>

    @if (keyData.length > 0) {
<div class="taskActivityBlock">
      <div class="taskActivityInnerBlock">
        <div class="keys-panel">
          <div class="key-search-wrap">
            <input type="text" class="form-control key-search-input"
                   [(ngModel)]="searchText" placeholder="Key Search">
            <i class="fa fa-search key-search-icon"></i>
          </div>
          <div class="col-border">
            @for (cacheKey of getFilteredKeys(keyData); track $index) {
<div class="keyList"
                 [ngClass]="{'selected': taskModel === cacheKey}"
                
                 (click)="getKeyJsonByName(selectedCache, cacheKey)">
              {{ cacheKey }}
            </div>
}
          </div>
        </div>
        <div class="json-panel">
          @if (showJSON) {
<div class="json-view-container">
            <div class="json-header old">JSON Data For Selected Key [{{ taskModel }}]</div>
            <div class="jsonContainer">
              <pre>{{ cacheKeyJsonView }}</pre>
            </div>
          </div>
}
          @if (showJsonLoader) {
<div class="jsonLoader">
            <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i>
          </div>
}
          @if (showSelectMsg) {
<div class="selectMsg">Select Key To View JSON</div>
}
        </div>
      </div>
    </div>
}
  
}

  <!-- ============ Tab 3: Index Deletion ============ -->
  @if (activeTab === 3) {

    <div class="index-deletion-controls">
      <select class="form-control input-sm inline-select"
              [(ngModel)]="selectedType">
        <option value="" disabled>Select Deletion Type</option>
        @for (index of indexDeletionDropdown; track $index) {
<option [value]="index.value">{{ index.label }}</option>
}
      </select>
      <span class="btn btn-success btn-sm action-btn" (click)="confirmDeletion()">Proceed</span>
      @if (deletionLoader) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    </div>
  
}
</div>

<!-- ============ Add Cache Modal ============ -->
@if (showAddCacheModal) {
<div class="admin-modal-overlay" (click)="closeAddCacheModal()">
  <div class="admin-modal-dialog add-cache-modal" (click)="$event.stopPropagation()">
    <div class="admin-modal">
      <div class="modal-header">
        <h3 class="modal-title">New Cache Definition</h3>
        <div class="header-actions">
          <i class="fa"
             [ngClass]="{'fa-plus-square-o': addCacheMinimise, 'fa-minus-square-o': !addCacheMinimise}"
             style="margin-right: 10px; cursor: pointer;"
             (click)="addCacheMinimise = !addCacheMinimise"></i>
          <i class="fa fa-times" style="cursor: pointer;" (click)="closeAddCacheModal()"></i>
        </div>
      </div>

      <div class="modal-body" [hidden]="addCacheMinimise">
        @if (addCacheLoading) {
<div class="cache-form-loader">
          <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i>
        </div>
}
        @if (!addCacheLoading) {
<div class="cache-form-wrap">
          <div class="cache-form-row cache-form-top">
            <div class="cache-field small">
              <label>Client Key:</label>
              <input class="form-control input-sm" [ngModel]="clientName" readonly>
            </div>
            <div class="cache-field">
              <label>Object Key:
                <i class="fa fa-info-circle"
                   ap-tooltip [tooltipContent]="'Example: CODE_COMBINATION'" [direction]="'bottom'"></i>
              </label>
              <input class="form-control input-sm" [(ngModel)]="cacheForm.object_key"
                     placeholder="enter object key">
              @if (cacheFormSubmitted && !cacheForm.object_key) {
<div class="form-error-container">Object Key is required.</div>
}
            </div>
            <div class="cache-field">
              <label>Object Name:
                <i class="fa fa-info-circle"
                   ap-tooltip [tooltipContent]="'Example: CODE COMBINATION'" [direction]="'bottom'"></i>
              </label>
              <input class="form-control input-sm" [(ngModel)]="cacheForm.object_name"
                     placeholder="enter object name">
              @if (cacheFormSubmitted && !cacheForm.object_name) {
<div class="form-error-container">Object Name is required.</div>
}
            </div>
          </div>

          <div class="cache-form-row">
            <div class="cache-field wide">
              <label>Input Parameters:</label>
              <input class="form-control input-sm" [(ngModel)]="cacheForm.proc_params_in"
                     placeholder="tax_year:String:null">
              @if (cacheFormSubmitted && !cacheForm.proc_params_in) {
<div class="form-error-container">Input Parameters is required.</div>
}
            </div>
            <div class="cache-field">
              <label>ex. In Parameters:</label>
              <select class="form-control input-sm" (ngModelChange)="setInPut($event)" [ngModel]="''">
                <option value="" disabled selected>Select</option>
                @for (item of exampleInList; track $index) {
<option [value]="item">{{ item }}</option>
}
              </select>
            </div>
          </div>

          <div class="cache-form-row">
            <div class="cache-field wide">
              <label>Output Parameters:</label>
              <input class="form-control input-sm" [(ngModel)]="cacheForm.proc_params_out"
                     placeholder="resultset:OracleTypes.CURSOR,retval:OracleTypes.VARCHAR,error_out:OracleTypes.VARCHAR">
              @if (cacheFormSubmitted && !cacheForm.proc_params_out) {
<div class="form-error-container">Output Parameters is required.</div>
}
            </div>
            <div class="cache-field">
              <label>ex. Out Parameters:</label>
              <select class="form-control input-sm" (ngModelChange)="setOutPut($event)" [ngModel]="''">
                <option value="" disabled selected>Select</option>
                @for (item of exampleOutList; track $index) {
<option [value]="item">{{ item }}</option>
}
              </select>
            </div>
          </div>

          <div class="cache-form-row">
            <div class="cache-field wide">
              <label>Stored Procedure Call:</label>
              <input class="form-control input-sm" [(ngModel)]="cacheForm.proc_call"
                     placeholder="begin gtw_test.proc_full_test(?,?,?,?,?,?,?);end;">
              @if (cacheFormSubmitted && !cacheForm.proc_call) {
<div class="form-error-container">Stored Procedure Call is required.</div>
}
            </div>
            <div class="cache-field">
              <label>ex. Proc Calls:</label>
              <select class="form-control input-sm" (ngModelChange)="setProc($event)" [ngModel]="''">
                <option value="" disabled selected>Select</option>
                @for (item of exampleProc; track $index) {
<option [value]="item">{{ item }}</option>
}
              </select>
            </div>
          </div>

          <div class="cache-form-row">
            <div class="cache-field wide">
              <label>Filter Condition(s):</label>
              <div class="input-group">
                <input class="form-control input-sm"
                       [(ngModel)]="cacheForm.filter_params"
                       [maxlength]="maxFilterLength"
                       placeholder="tax_year:2016,scenario:21,jcd_key:250">
                <span class="input-group-addon">{{ remainingFilterChars }}</span>
              </div>
              @if (isFilterLimitReached) {
<div class="form-error-container">Filter condition max length reached</div>
}
              @if (cacheFormSubmitted && !cacheForm.filter_params) {
<div class="form-error-container">Filter Condition is required.</div>
}
            </div>
            <div class="cache-field">
              <label>ex. Condition(s):</label>
              <select class="form-control input-sm" (ngModelChange)="setFilters($event)" [ngModel]="''">
                <option value="" disabled selected>Select</option>
                @for (item of filterConditions; track $index) {
<option [value]="item">{{ item }}</option>
}
              </select>
            </div>
          </div>
        </div>
}
      </div>

      <div class="modal-footer" [hidden]="addCacheMinimise">
        <button class="btn btn-primary btn-sm" type="button"
                (click)="saveCacheDefinition()" [disabled]="addCacheLoading">
          Save @if (addCacheLoading) {
<i class="fa fa-spinner fa-spin"></i>
}
        </button>
        <button class="btn btn-info btn-sm" type="button" (click)="closeAddCacheModal()">Cancel</button>
      </div>
    </div>
  </div>
</div>
}

<!-- ============ JSON Diff Modal ============ -->
@if (showDiffDialog) {
<div class="admin-modal-overlay" (click)="closeDiffModal()">
  <div class="admin-modal-dialog diff-modal" (click)="$event.stopPropagation()">
    <div class="admin-modal">
      <div class="modal-header">
        <h3 class="modal-title">{{ diffModalTitle }}</h3>
        <div class="header-actions">
          <i class="fa fa-times" style="cursor: pointer;" (click)="closeDiffModal()"></i>
        </div>
      </div>

      <div class="modal-body diff-body">
        @if (showJsonLoader) {
<div class="cache-form-loader">
          <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i>
        </div>
}
        @if (!showJsonLoader) {
<div class="diff-grid">
          <div class="diff-col">
            <span class="diff-label old">JSON Data From Redis, &nbsp; Total Records = {{ diffRedisCount }}</span>
            <pre class="diff-pre" [innerHTML]="diffRedisJsonView"></pre>
            <span class="diff-label new">JSON Data From Database, &nbsp; Total Records = {{ diffDbCount }}</span>
            <pre class="diff-pre" [innerHTML]="diffDbJsonView"></pre>
          </div>
          <div class="diff-col">
            <span class="diff-label diff-changes">OLD / NEW JSON Differences</span>
            <pre class="diff-pre diff-full-height" [innerHTML]="diffChangesView"></pre>
          </div>
        </div>
}
      </div>

      <div class="modal-footer">
        <button class="btn btn-info btn-sm" type="button" (click)="closeDiffModal()">Cancel</button>
      </div>
    </div>
  </div>
</div>
}

<!-- ============ Confirmation Dialog ============ -->
@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onConfirmYes()"
    (cancelled)="onConfirmNo()"
    (closed)="onConfirmNo()">
  </gtw-confirmation-modal>
</div>
}
